'use client';

import { Transition } from '@headlessui/react';
import { RichTextField } from '@prismicio/client';
import { PrismicRichText } from '@prismicio/react';

interface Props {
  disclosureClassName: string;
  disclosureTitle: RichTextField;
  disclosurePanel: RichTextField;
  isOpen: boolean;
  onClick: () => void;
}

export const Disclosure = ({
  disclosureTitle,
  disclosurePanel,
  disclosureClassName,
  isOpen,
  onClick,
}: Props) => {
  return (
    <div className={disclosureClassName}>
      <button
        onClick={onClick}
        className="flex justify-between w-full text-left focus:outline-none"
      >
        <PrismicRichText field={disclosureTitle} />
      </button>
      <Transition
        show={isOpen}
        unmount={false}
        enter="transition duration-200 ease-out"
        enterFrom="transform -translate-y-2 opacity-0"
        enterTo="transform translate-y-0 opacity-100"
        leave="transition duration-200 ease-in"
        leaveFrom="transform translate-y-0 opacity-100"
        leaveTo="transform -translate-y-2 opacity-0"
      >
        <div className="mt-2 origin-top">
          <PrismicRichText field={disclosurePanel} />
        </div>
      </Transition>
    </div>
  );
};
